var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lost-password-page"},[_c('a-card',{staticClass:"card",attrs:{"dis-hover":""}},[_c('h2',{staticClass:"text-center"},[_vm._v("不开放使用")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }